export const SIDEBAR_DRAWER_CLASS_NAME = 'sidebar-drawer';
export const NAV_DRAWER_CLASS_NAME = 'nav-drawer';
export const SIDE_PANEL_DRAWER_CLASS_NAME = 'side-panel-drawer';
